module.exports = __webpack_public_path__ + "media/images/black_history_month/play-icon-522bb11285ac786497df80d9c1e441e1.svg";